import { render, staticRenderFns } from "./epms9010_detail.vue?vue&type=template&id=4ebc34e2&scoped=true"
import script from "./epms9010_detail.vue?vue&type=script&lang=js"
export * from "./epms9010_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebc34e2",
  null
  
)

export default component.exports